import React from 'react';
import { BoxWithIcon } from '../BoxWithIcon/BoxWithIcon';
import { InfoNote } from '../InfoNote/InfoNote';
import { ProductWizardTitle } from '../ProductWizard/ProductWizardTitle/ProductWizardTitle';
import { ProductWizardTransLink } from '../ProductWizardTransLink/ProductWizardTransLink';
import type { ChoiceStepsProps } from './ChoiceSteps.types';
import clsx from 'clsx';

import useStyles from './ChoiceSteps.style';

const ChoiceSteps: React.FC<ChoiceStepsProps> = ({
  titleKey,
  subtitle,
  options,
  notes
}) => {
  const c = useStyles({});

  return (
    <div data-testid="choice-steps-container">
      <ProductWizardTitle titleKey={titleKey} subtitle={subtitle} />

      <div className={c.container} data-testid="choice-steps-options">
        {options.map( option => (
          <ProductWizardTransLink
            key={option.path}
            path={option.path}
            currentScreenCode={option.currentScreenCode}
            className={clsx(c.boxWithIconWrapper, option.className)}
            onClick={option.onClick}
          >
            <BoxWithIcon
              title={option.title}
              subtitle={option.subtitle}
              icon={option.icon}
            />
          </ProductWizardTransLink>
        ))}
      </div>

      {notes && notes.length > 0 && (
        <div className={c.noteContainer} data-testid="choice-steps-notes">
          {notes.length === 1 ? (
            <InfoNote
              title={notes[0].title}
              subtitle={notes[0].subtitle}
              icon={notes[0].icon}
              transNamespace={notes[0].transNamespace}
              transKey={notes[0].transKey}
              transValues={notes[0].transValues}
            />
          ) : (
            notes.map( note => (
              <div key={`note-${note.title}`} className={c.noteWrapper}>
                <InfoNote
                  title={note.title}
                  subtitle={note.subtitle}
                  icon={note.icon}
                  transNamespace={note.transNamespace}
                  transKey={note.transKey}
                  transValues={note.transValues}
                />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export { ChoiceSteps };
